// extracted by mini-css-extract-plugin
module.exports = {"gallery_images":"galleryImage_gallery_images__oWOrk"};